import { createContext } from 'react';
import { ICreateRestaurantWatchesCommandsFile, TWatchesCommandsTypes } from 'types';
import { watchesCommandsTypes } from 'appConstants';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';
export interface ICreateWatchesData {
	restaurantID: string;
	data: ICreateRestaurantWatchesCommandsFile;
}
export interface IWatchesRanges {
	id: string;
	range: string;
}
export const NEW_WATCHES_TABLE_RANGES_PREFIX = 'newWatchesTableRanges';
export const NEW_ADMIN_WATCHES_TABLE_RANGES_PREFIX = 'newAdminWatchesTableRanges';
export const regexForRanges = /^(?!^\d+(\.\d+)?$)\d+(\.\d+)?(-\d+(\.\d+)?)*(;\d+(\.\d+)?-\d+(\.\d+)?)*$/;
export const defaultSelectedCommand = watchesCommandsTypes.reduce((acc: TWatchesCommandsTypes[], command) => {
	return command.disabled ? [...acc, command.id] : acc;
}, []);

export interface IWatchesState {
	watchesQuantity: null | number;
	adminWatchesQuantity: null | number;
	commands: TWatchesCommandsTypes[];
	watchesTableRanges: IWatchesRanges[];
	adminWatchesTableRanges: IWatchesRanges[];
	dataForSubmit: ICreateWatchesData | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const watchesInitialState: IWatchesState = {
	watchesQuantity: null,
	adminWatchesQuantity: null,
	commands: defaultSelectedCommand,
	watchesTableRanges: [],
	adminWatchesTableRanges: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IWatchesContext extends IWatchesState {
	setWatchesQuantity(value: null | number): void;
	setAdminWatchesQuantity(value: null | number): void;
	setCommands(value: TWatchesCommandsTypes[]): void;
	changeWatchesTableRanges(rangeId: string, range: string): void;
	changeAdminWatchesTableRanges(rangeId: string, range: string): void;
	setDataForSubmit(value: ICreateWatchesData | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const WatchesContext = createContext<IWatchesContext>({
	setWatchesQuantity: () => undefined,
	setAdminWatchesQuantity: () => undefined,
	setCommands: () => undefined,
	changeWatchesTableRanges: () => undefined,
	changeAdminWatchesTableRanges: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...watchesInitialState,
});
